import { useState } from 'react';
import { Tabs } from '@usealloy/component-library';

import { RiskRatingCard } from '../../RiskRatingCard/RiskRatingCard';
import { RiskScoreTabLabel } from '../../RiskRatingCard/RiskScoreTabLabel';
import type { CoreRiskData } from '../../RiskRatingCard/useRiskData';
import { useEventTypeEvaluationsContext } from '../context';
import { ExternalAccountCreatedOverview } from './ExternalAccountCreatedOverview';
import { TAB_VALUES } from '../tabs/constants';

interface ExternalAccountCreatedTabsProps {
  riskData: CoreRiskData;
  canViewRiskFormula: boolean;
}

export const ExternalAccountCreatedTabs = ({
  riskData,
  canViewRiskFormula,
}: ExternalAccountCreatedTabsProps) => {
  const [tab, setTab] = useState(TAB_VALUES.OVERVIEW);
  const { evaluation } = useEventTypeEvaluationsContext();
  const {
    riskFactors,
    riskFormula,
    riskRangeValues,
    riskRatingColor,
    riskRatingLabel,
    totalRisk,
  } = riskData;

  const tabs = [
    {
      label: 'Overview',
      value: TAB_VALUES.OVERVIEW,
      content: <ExternalAccountCreatedOverview />,
    },
    {
      label: (
        <RiskScoreTabLabel
          riskRatingColor={riskRatingColor}
          riskRatingLabel={riskRatingLabel}
        />
      ),
      value: TAB_VALUES.RISK_SCORE,
      content: (
        <RiskRatingCard
          canViewRiskFormula={canViewRiskFormula}
          entityToken={evaluation.entity_token}
          evaluationToken={evaluation.evaluation_token}
          evaluationType={evaluation.evaluation_type}
          riskFactors={riskFactors}
          riskOutputFormula={riskFormula}
          riskRanges={riskRangeValues}
          riskValue={totalRisk}
          riskValueColor={riskRatingColor}
          riskValueLabel={riskRatingLabel}
          variant="entityRisk"
          workflowToken={evaluation.application_token}
          workflowVersion={evaluation.public_version}
        />
      ),
    },
  ];

  return (
    <Tabs
      style={{ width: '100%' }}
      tabs={tabs}
      onValueChange={setTab}
      value={tab}
    />
  );
};
